<script lang="ts">
    import { defineCustomElement as advPopup } from '@didi/adv-ui/adv-retention-dialog';
    import { onMount } from 'svelte';

    import {
        END_CARD_RETENTION,
        END_CARD_RETENTION_CONFIRM,
        END_CARD_RETENTION_CONFIRM_COLOR,
        END_CARD_RETENTION_TEXT,
        END_CARD_RETENTION_TITLE,
        REGULAR_CARD_RETENTION
    } from '../constants/imgList';
    import { BALL_PAGE_TYPE } from '../constants/pageType';
    import { POPUP_ID } from '../enums';
    import { RETAIN_POPUP_CK } from '../enums/track';
    import {
        ballPageType,
        isJumpOneLink,
        omegaParams,
        showRetentionPopup,
        trackRoute
    } from '../store/index';
    import { trackEvent } from '../utils/track';

    import { markPopBegin, markPopEnd } from '@/utils/fmpTrack';

    export let bid = 'creditcard';
    export let isOnePage = 'true';

    $: pageVariant = $ballPageType;

    $: fifaHeaderImg =
        pageVariant === BALL_PAGE_TYPE.END
            ? END_CARD_RETENTION
            : REGULAR_CARD_RETENTION;

    /** msi：登录子路由 / 跳转中抑制挽留；regular/end：仅跳转中抑制 */
    $: deepLinkState =
        pageVariant === BALL_PAGE_TYPE.MSI
            ? $trackRoute === '/login'
                ? true
                : $isJumpOneLink && $showRetentionPopup
            : $isJumpOneLink;

    const handleShowPopup = (event: CustomEvent) => {
        if (event.detail) {
            markPopBegin({ popup_id: POPUP_ID.RETENTION_POPUP });
        }
    };

    const handleVisible = (event: CustomEvent) => {
        if (event.detail) {
            markPopEnd({ popup_id: POPUP_ID.RETENTION_POPUP });
        }
    };

    const handlePopupClose = (event: CustomEvent) => {
        if (event?.detail?.closeType === 'close') {
            trackEvent(RETAIN_POPUP_CK, {
                button_name: 'close',
                is_jump_success: 0
            });

            return;
        }

        if (event?.detail?.closeType === 'confirm') {
            trackEvent(RETAIN_POPUP_CK, {
                button_name: 'cta',
                is_jump_success: 0
            });
        }
    };

    onMount(() => {
        advPopup();
    });
</script>

<adv-retention-dialog
    {bid}
    is-fifa="true"
    fifa-header-img={fifaHeaderImg}
    credit-card-title={END_CARD_RETENTION_TITLE}
    credit-card-text={END_CARD_RETENTION_TEXT}
    confirm-text={END_CARD_RETENTION_CONFIRM}
    confirm-color={END_CARD_RETENTION_CONFIRM_COLOR}
    is-one-page={isOnePage}
    params={$omegaParams}
    is-jump-app="false"
    deepLinkState={deepLinkState}
    on:popupClose={handlePopupClose}
    on:isVisible={handleVisible}
    on:showPopupState={handleShowPopup}
></adv-retention-dialog>
